<template>
	<v-card>
		<v-card-title class="d-flex align-center">
			<v-icon
				start
				icon="$pdf"
			/>
			<translate>PDF Templates</translate>
		</v-card-title>
		<v-card-text>
			<v-data-table
				:headers="headers"
				:loading="tableLoading"
				:items="data"
				must-sort
			>
				<template #item="{ item: template }">
					<tr>
						<td> {{ template['name'] }} </td>
						<td> {{ template['domainName'] }} </td>
						<td v-if="template.languages.length > 1">
							<v-layout justify-end>
								<v-menu>
									<template #activator="{ props }">
										<v-btn
											v-bind="props"
											variant="text"
											icon
											color="primary"
										>
											<v-icon icon="$menuDown" />
										</v-btn>
									</template>
									<v-list>
										<v-list-item
											v-for="(item, index) in template.languages"
											:key="index"
											@click="select(item)"
										>
											<v-list-item-title>
												<v-icon
													style="color: #68bd45"
													icon="$pencil"
												/>
												{{ item['languageName'] }}
											</v-list-item-title>
										</v-list-item>
									</v-list>
								</v-menu>
							</v-layout>
						</td>
						<td v-else>
							<v-layout end>
								<v-btn
									variant="text"
									icon
									color="primary"
									@click="select(template.languages[0])"
								>
									<v-icon icon="$pencil" />
								</v-btn>
							</v-layout>
						</td>
					</tr>
				</template>
			</v-data-table>
		</v-card-text>
	</v-card>
</template>

<script>

import {
	axios,
} from '../../../../services/axios-service';
import {
	displayError,
} from 'laravel-front-library';

export default {
	data () {
		return {
			headers: [
				{
					title: 'Template Name',
					value: 'name',
					sortable: true,
				},
				{
					title: 'Domain',
					value: 'domain_name',
					sortable: true,
				},
				{
					title: '',
					value: 'languages',
					sortable: true,
				},
			],
			tableLoading: false,
			pageLoading: false,
			data: [],
		};
	},

	created () {
		this.getData();
	},

	methods: {

		/**
		 * Triggers when a specific pdf template is selected by the user, takes them to the
		 * relevant page.
		 *
		 * @param {object} template - The template selected by the user
		 * @returns {void}
		 */
		select (template) {
			window.location.href = `/bo/pdftemplates/view?id=${template.id}`;
		},

		/**
		 * Retrieves the table data
		 *
		 * @returns {void}
		 */
		getData () {
			if (this.table !== null) {
				this.tableLoading = true;
				axios.get('/bo/pdftemplates/index').then(({
					data,
				}) => {
					this.data = data.items;
					this.tableLoading = false;
					this.pageLoading = false;
				}).catch(displayError);
			}
		},
	},
};

</script>
